module.exports = __webpack_public_path__ + "media/images/duel/conflict-2-1e0f4e3c3c95f18c37ab3e559afe7112.jpg";